if (!customElements.get('read-more')) {
class ReadMore extends HTMLElement {
  constructor() {
    super();
    this.isExpanded = false;
    this.originalContent = '';
  }

  connectedCallback() {
    this.desktopLines = parseInt(this.getAttribute('desktop-lines') || '3');
    this.mobileLines = parseInt(this.getAttribute('mobile-lines') || '2');
    this.readMoreText = this.getAttribute('read-more-text') || 'Read more';
    this.readLessText = this.getAttribute('read-less-text') || 'Read less';
    
    this.originalContent = this.innerHTML;
    this.init();
  }

  init() {
    this.innerHTML = `
      <div class="read-more__content" style="--desktop-lines: ${this.desktopLines}; --mobile-lines: ${this.mobileLines};">
        ${this.originalContent}
      </div>
      <button class="read-more__toggle btn--underline" type="button">
        ${this.readMoreText}
      </button>
    `;

    this.contentElement = this.querySelector('.read-more__content');
    this.toggleButton = this.querySelector('.read-more__toggle');
    
    this.toggleButton.addEventListener('click', () => this.toggle());
    
    // Check if content needs truncation
    this.checkOverflow();
    window.addEventListener('resize', () => this.checkOverflow());
  }

  checkOverflow() {
    // Reset to check natural height
    this.contentElement.style.maxHeight = 'none';
    this.contentElement.classList.remove('read-more__content--clamped');
    
    const lineHeight = parseInt(window.getComputedStyle(this.contentElement).lineHeight);
    const isMobile = window.innerWidth < 768;
    const maxLines = isMobile ? this.mobileLines : this.desktopLines;
    const maxHeight = lineHeight * maxLines;
    
    if (this.contentElement.scrollHeight > maxHeight && !this.isExpanded) {
      this.contentElement.classList.add('read-more__content--clamped');
      this.toggleButton.style.display = 'inline-block';
    } else if (!this.isExpanded) {
      this.toggleButton.style.display = 'none';
    }
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
    
    if (this.isExpanded) {
      this.contentElement.classList.remove('read-more__content--clamped');
      this.contentElement.style.maxHeight = 'none';
      this.toggleButton.textContent = this.readLessText;
    } else {
      this.contentElement.classList.add('read-more__content--clamped');
      this.toggleButton.textContent = this.readMoreText;
      this.checkOverflow();
    }
  }
}

customElements.define('read-more', ReadMore);
}
